import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

type Props = {
    onToggleMenu: (event: any) => void;
}

export function AppTopbar(props: Props) {

    return (
        <div className="layout-topbar clearfix">
            <a className="layout-menu-button" onClick={props.onToggleMenu} href='/'>
                <span ><i className="pi pi-bars"></i></span>
            </a>
            <Link to={"/"} style={{ marginLeft: 25}} >
                <img src='/empx.png' style={{height: 25}} alt="logo" />
            </Link>
        </div>
    );

}